
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"76","height":"76","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.988 25.694A11.978 11.978 0 012 13.706V2h23.977v11.636c0 6.628-5.36 12.058-11.989 12.058z"}}),_c('path',{attrs:{"d":"M37.965 25.694a11.978 11.978 0 01-11.989-11.988V2h23.977v11.636c0 6.628-5.36 12.058-11.988 12.058zM37.965 26.752v11.636c0 6.629-5.36 11.988-11.989 11.988a11.978 11.978 0 01-11.988-11.988V26.752"}}),_c('path',{attrs:{"d":"M13.988 26.752v11.636c0 6.629-5.36 11.988-11.988 11.988M61.941 26.752v11.636c0 6.629 5.36 11.988 11.988 11.988M61.941 26.752v11.636c0 6.629-5.36 11.988-11.988 11.988a11.978 11.978 0 01-11.988-11.988V26.752M61.941 25.694a11.978 11.978 0 01-11.988-11.988V2H73.93v11.636c0 6.628-5.36 12.058-11.989 12.058zM25.977 50.376v11.636C25.977 68.64 20.617 74 13.988 74A11.978 11.978 0 012 62.012V50.376"}}),_c('path',{attrs:{"d":"M49.953 50.376v11.636C49.953 68.64 44.593 74 37.965 74a11.978 11.978 0 01-11.989-11.988V50.376"}}),_c('path',{attrs:{"d":"M73.93 50.376v11.636C73.93 68.64 68.57 74 61.94 74a11.978 11.978 0 01-11.988-11.988V50.376"}})])
          )
        }
      }
    